module.exports = __webpack_public_path__ + "img/5d29dc2d5dad4ae93acfc5e59948b07a.png";